var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-sticky social-sticky-bgdark-colorwhite "},_vm._l((_vm.socials),function(social,index){return _c('span',{staticClass:"link-icon social-sticky-item",class:index,attrs:{"title":social},on:{"click":function($event){return _vm.share(index)}}},[_c('i',{staticClass:"transition ",class:_vm.classes[index],attrs:{"title":social}})])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4ecc79e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/ShareButtons.vue
// module id = fudn
// module chunks = 2